import { unitaByte } from './unita';
// VELOCITA' E TEMPO RIMANENTE, SU UNA FINESTRA MOBILE (2026-09-13).
//
// La media dall'inizio e' sempre sbagliata, e sbaglia sempre nella stessa
// direzione: un trasferimento che parte veloce e poi rallenta continua a
// promettere il ritmo dei primi secondi, e il tempo rimanente scende piano
// e poi si blocca. Chi guarda impara a non fidarsi del numero, che tanto
// vale non mostrarlo.
//
// Qui si tengono gli ultimi campioni (istante, byte) e si guarda solo quelli:
// la velocita' e' quella di ADESSO, e il tempo rimanente la segue.
const FINESTRA_MS = 5000;
// Sotto un secondo di storia qualunque numero e' rumore: due campioni a
// 80 ms di distanza darebbero una velocita' inventata.
const STORIA_MINIMA_MS = 1000;

export function creaMisuratore() {
  let campioni = [];   // { t, byte }

  return {
    /** byte = totale trasferito finora, non l'incremento. */
    segna(byte) {
      const t = Date.now();
      campioni.push({ t, byte });
      const taglio = t - FINESTRA_MS;
      // Si tiene un campione appena fuori finestra: serve a misurare
      // l'intervallo che l'attraversa, altrimenti la prima misura dopo la
      // potatura sarebbe piu' corta del dovuto.
      let primo = 0;
      while (primo + 1 < campioni.length && campioni[primo + 1].t < taglio) primo += 1;
      if (primo > 0) campioni = campioni.slice(primo);
    },

    /** byte al secondo, oppure null quando non c'e' abbastanza storia. */
    velocita() {
      if (campioni.length < 2) return null;
      const a = campioni[0];
      const z = campioni[campioni.length - 1];
      const dt = z.t - a.t;
      if (dt < STORIA_MINIMA_MS) return null;
      const db = z.byte - a.byte;
      if (db <= 0) return 0;
      return (db * 1000) / dt;
    },

    /** secondi mancanti, oppure null se non si puo' dire. */
    restano(byteTotali) {
      const v = this.velocita();
      if (!v || !byteTotali) return null;
      const fatti = campioni[campioni.length - 1].byte;
      const mancano = byteTotali - fatti;
      if (mancano <= 0) return 0;
      return Math.round(mancano / v);
    },

    azzera() { campioni = []; },
  };
}

/** "4,2 MB/s" — con la virgola in italiano, il punto in inglese. */
export function velocitaLeggibile(bytePerSecondo, lingua) {
  if (bytePerSecondo == null) return null;
  const virgola = lingua === 'en' ? '.' : ',';
  const mb = bytePerSecondo / (1024 * 1024);
  if (mb >= 1) return mb.toFixed(1).replace('.', virgola) + ' ' + unitaByte(lingua, 'MB') + '/s';
  const kb = bytePerSecondo / 1024;
  return Math.round(kb) + ' ' + unitaByte(lingua, 'kB') + '/s';
}

/** "2 min 30 s" — mai "0 s", mai numeri a sei cifre. */
export function tempoLeggibile(secondi, lingua) {
  if (secondi == null) return null;
  const en = lingua === 'en';
  const es = lingua === 'es', fr = lingua === 'fr', de = lingua === 'de';
  if (secondi < 5) return en ? 'a few seconds' : es ? 'unos segundos' : fr ? 'quelques secondes' : de ? 'wenige Sekunden' : 'pochi secondi';
  if (secondi < 60) return Math.round(secondi) + ' s';
  const min = Math.floor(secondi / 60);
  const s = Math.round(secondi % 60);
  if (min < 60) return s > 0 ? `${min} min ${s} s` : `${min} min`;
  const ore = Math.floor(min / 60);
  // Oltre le tre ore il numero non aiuta piu' nessuno: si dice che e' tanto.
  if (ore >= 3) return en ? 'more than 3 hours' : es ? 'más de 3 horas' : fr ? 'plus de 3 heures' : de ? 'mehr als 3 Stunden' : 'oltre 3 ore';
  return `${ore} h ${min % 60} min`;
}
